export default "__VITE_ASSET__3rB_$EfS__"